import {
  FetchMFAPreferenceOutput,
  updateMFAPreference,
} from "aws-amplify/auth";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { SMS2FAForm } from "@/features/registration/components/sms-2fa.form";
import { queryClient } from "@/lib/react-query";

type AddSmsModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isEnabled: boolean;
  enabled: FetchMFAPreferenceOutput["enabled"];
};

export function AddSmsModal({
  open,
  onOpenChange,
  isEnabled,
  enabled,
}: AddSmsModalProps) {
  const handleSuccess = async () => {
    const isTotpEnabled = enabled?.includes("TOTP");
    const isEmailEnabled = enabled?.includes("EMAIL");

    await updateMFAPreference({
      sms: "ENABLED",
      totp: isTotpEnabled ? "ENABLED" : "DISABLED",
      email: isEmailEnabled ? "ENABLED" : "DISABLED",
    });

    await queryClient.refetchQueries({ queryKey: ["mfa"] });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {!isEnabled && (
        <DialogTrigger asChild>
          <Button variant="link">+ Add SMS</Button>
        </DialogTrigger>
      )}
      <DialogContent
        aria-describedby={undefined}
        className="rounded-none border-none bg-transparent p-0"
      >
        <DialogTitle className="sr-only">Add SMS 2FA</DialogTitle>
        <SMS2FAForm
          goBack={() => onOpenChange(false)}
          onSuccess={handleSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
